/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import {
  useState, useRef, useEffect, memo
} from 'react';
import { motion } from 'framer-motion';
import {
  FaCalendarAlt, FaFileInvoiceDollar, FaChartBar, FaMobileAlt, FaUsers, FaCar,
  FaFolderOpen, FaDatabase, FaWarehouse, FaRocket, FaShieldAlt, FaSyncAlt
} from 'react-icons/fa';
import Slider from 'react-slick';
import Swal from 'sweetalert2';
import backgroundImg from '../../images/quotesDrive.png';

// -------------------------
// VARIANTS D'ANIMATION
// -------------------------
const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};

const staggerVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const itemVariant = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.4, ease: 'easeOut' } }
};

// -------------------------
// STYLES DE BASE & VARIABLES
// -------------------------
const colors = {
  primary: '#3a86ff',
  secondary: '#ff006e',
  accent: '#8338ec',
  success: '#06d6a0',
  warning: '#ffbe0b',
  dark: '#1e2a3a',
  light: '#f8f9fa',
  darkGradient: 'linear-gradient(135deg, #0b1120 0%, #1e293b 100%)',
  glassEffect: 'rgba(255, 255, 255, 0.03)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
};

const fontFamily = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const heroStyle = {
  backgroundImage: `url(${backgroundImg})`,
  width: '100%',
  minHeight: '100vh',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const overlayStyle = {
  background: 'linear-gradient(135deg, rgba(14, 25, 45, 0.85) 0%, rgba(30, 42, 58, 0.8) 100%)',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
};

const contentStyle = {
  position: 'relative',
  zIndex: 2,
  textAlign: 'center',
  padding: '0 20px',
  maxWidth: '1200px',
  width: '100%',
  color: colors.light,
  fontFamily,
};

const headlineStyle = {
  fontSize: 'clamp(2.5rem, 5vw, 4rem)',
  fontWeight: '800',
  marginBottom: '30px',
  background: 'linear-gradient(90deg, #ffffff 0%, #a2d6fc 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  letterSpacing: '-0.5px',
  lineHeight: '1.2',
};

const subheadStyle = {
  fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
  fontWeight: '400',
  marginBottom: '50px',
  maxWidth: '700px',
  margin: '0 auto 50px',
  color: 'rgba(255, 255, 255, 0.85)',
  lineHeight: '1.6',
};

const buttonStyle = {
  backgroundColor: colors.primary,
  color: colors.light,
  fontWeight: '600',
  padding: '16px 36px',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  boxShadow: '0 10px 25px rgba(58, 134, 255, 0.3)',
  fontSize: '1.125rem',
  fontFamily,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10px',
  textTransform: 'none',
  transition: 'all 0.3s ease',
};

const secondaryButtonStyle = {
  ...buttonStyle,
  backgroundColor: 'transparent',
  border: `2px solid ${colors.light}`,
  boxShadow: 'none',
  color: colors.light,
};

const sectionStyle = {
  padding: '120px 24px',
  backgroundColor: colors.light,
  fontFamily,
  position: 'relative',
  overflow: 'hidden',
};

const sectionHeadingStyle = {
  fontSize: 'clamp(2rem, 3vw, 2.75rem)',
  fontWeight: '800',
  color: colors.dark,
  marginBottom: '16px',
  textAlign: 'center',
  position: 'relative',
};

const sectionSubheadingStyle = {
  fontSize: 'clamp(1rem, 1.5vw, 1.2rem)',
  color: '#64748b',
  textAlign: 'center',
  maxWidth: '700px',
  margin: '0 auto 60px',
  lineHeight: '1.6',
};

const inputStyle = {
  width: '100%',
  padding: '18px 20px',
  margin: '8px 0',
  boxSizing: 'border-box',
  border: 'none',
  background: '#f1f5f9',
  borderRadius: '12px',
  fontSize: '1rem',
  fontFamily,
  transition: 'all 0.3s ease',
  boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.03)',
};

const formButtonStyle = {
  ...buttonStyle,
  fontWeight: 'bold',
  letterSpacing: '0.5px',
  padding: '18px 40px',
  borderRadius: '12px',
  width: '100%',
  maxWidth: '200px',
};

// Nouveaux styles pour l'aspect futuriste
const glowEffect = {
  position: 'absolute',
  width: '150px',
  height: '150px',
  borderRadius: '50%',
  filter: 'blur(50px)',
  zIndex: 0,
  opacity: 0.4,
};

const shapesStyles = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  top: 0,
  left: 0,
  zIndex: 0,
};

const circleShape = {
  position: 'absolute',
  borderRadius: '50%',
  background: 'rgba(58, 134, 255, 0.15)',
  filter: 'blur(40px)',
  zIndex: 0,
  opacity: 0.5,
};

// -------------------------
// SECTIONS SUPPLÉMENTAIRES
// -------------------------
// Memoize child components to prevent unnecessary re-renders
const AboutSection = memo(() => (
  <motion.section
    style={{
      ...sectionStyle,
      background: 'linear-gradient(135deg, #f8f9fa 0%, #f1f5f9 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}
    variants={fadeInUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    {/* Formes d'arrière-plan */}
    <div style={shapesStyles}>
      <div style={{
        ...circleShape,
        width: '400px',
        height: '400px',
        top: '-100px',
        left: '-100px',
        background: 'rgba(131, 56, 236, 0.08)',
      }}
      />
      <div style={{
        ...circleShape,
        width: '300px',
        height: '300px',
        bottom: '-50px',
        right: '-50px',
        background: 'rgba(58, 134, 255, 0.08)',
      }}
      />
    </div>

    <div style={{
      position: 'relative', zIndex: 1, maxWidth: '1200px', margin: '0 auto'
    }}
    >
      <motion.div
        variants={staggerVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.div variants={itemVariant}>
          <h2 style={{
            ...sectionHeadingStyle,
            textAlign: 'left',
            position: 'relative',
            marginBottom: '20px',
            display: 'inline-block'
          }}
          >
            À propos de nous
            <div style={{
              position: 'absolute',
              bottom: '-10px',
              left: '0',
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #3a86ff, #8338ec)',
              borderRadius: '2px'
            }}
            />
          </h2>
        </motion.div>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '60px'
        }}
        >
          <motion.div variants={itemVariant} style={{ flex: '1 1 400px' }}>
            <h3 style={{
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '30px',
              color: colors.dark,
              lineHeight: '1.3'
            }}
            >
              Révolutionnez votre gestion de transport sanitaire
            </h3>
            <p style={{
              fontSize: '1.1rem',
              lineHeight: '1.8',
              color: '#64748b',
              marginBottom: '30px'
            }}
            >
              Drivesoft est une solution innovante et personnalisable qui révolutionne la gestion du transport sanitaire.
              Nous apportons une fraîcheur bienvenue par rapport aux solutions existantes, avec une technologie de pointe pour optimiser vos opérations.
            </p>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              marginTop: '40px'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px'
              }}
              >
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  background: 'rgba(58, 134, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: colors.primary,
                  fontSize: '20px'
                }}
                >
                  <FaRocket />
                </div>
                <div>
                  <h4 style={{
                    fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px', color: colors.dark
                  }}
                  >Innovation
                  </h4>
                  <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Technologie de pointe</p>
                </div>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px'
              }}
              >
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  background: 'rgba(255, 0, 110, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: colors.secondary,
                  fontSize: '20px'
                }}
                >
                  <FaShieldAlt />
                </div>
                <div>
                  <h4 style={{
                    fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px', color: colors.dark
                  }}
                  >Sécurité
                  </h4>
                  <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Protection des données</p>
                </div>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px'
              }}
              >
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  background: 'rgba(131, 56, 236, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: colors.accent,
                  fontSize: '20px'
                }}
                >
                  <FaSyncAlt />
                </div>
                <div>
                  <h4 style={{
                    fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px', color: colors.dark
                  }}
                  >Adaptabilité
                  </h4>
                  <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Solution personnalisable</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            variants={itemVariant}
            style={{
              flex: '1 1 400px',
              position: 'relative',
              height: '400px'
            }}
          >
            <div style={{
              position: 'absolute',
              width: '80%',
              height: '80%',
              background: 'linear-gradient(135deg, rgba(58, 134, 255, 0.2) 0%, rgba(131, 56, 236, 0.2) 100%)',
              borderRadius: '24px',
              top: '10%',
              left: '10%',
              zIndex: 1,
              backdropFilter: 'blur(40px)',
              boxShadow: '0 30px 60px rgba(0, 0, 0, 0.12)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}
            >
              <div style={{
                border: '2px dashed rgba(255, 255, 255, 0.3)',
                borderRadius: '20px',
                padding: '30px',
                width: '80%',
                height: '80%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                color: colors.dark
              }}
              >
                <h3 style={{ fontWeight: '700', marginBottom: '20px' }}>Une interface intuitive</h3>
                <p style={{ fontSize: '0.95rem', lineHeight: '1.8', color: '#475569' }}>Notre interface s'adapte à vos besoins et offre une expérience utilisateur exceptionnelle, conçue pour faciliter votre travail quotidien.</p>
              </div>
            </div>
            <div style={{
              position: 'absolute',
              width: '70%',
              height: '70%',
              borderRadius: '24px',
              bottom: 0,
              right: 0,
              zIndex: 0,
              background: 'linear-gradient(135deg, rgba(255, 0, 110, 0.1) 0%, rgba(255, 190, 11, 0.1) 100%)',
              boxShadow: '0 30px 60px rgba(0, 0, 0, 0.06)'
            }}
            />
          </motion.div>
        </div>
      </motion.div>
    </div>
  </motion.section>
));

const TestimonialsSection = memo(() => {
  const testimonials = [
    {
      name: 'Sophie L.',
      role: 'Directrice de société de transport',
      text: "Grâce à Drivesoft, notre gestion quotidienne s'est transformée. Une vraie révolution pour notre organisation ! L'interface intuitive nous a permis d'améliorer notre productivité de 40%.",
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
    },
    {
      name: 'Julien D.',
      role: 'Responsable exploitation',
      text: 'La solution est intuitive et complète. Nous avons gagné en efficacité dès les premières semaines. Le support technique est réactif et les mises à jour régulières améliorent constamment le service.',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    {
      name: 'Claire M.',
      role: 'Administratrice',
      text: 'Un accompagnement et un support impeccables, Drivesoft nous aide à relever tous nos défis. La formation a été complète et la prise en main rapide pour toute notre équipe.',
      avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
    },
  ];

  return (
    <motion.section
      style={{
        ...sectionStyle,
        backgroundColor: colors.dark,
        background: colors.darkGradient,
        color: colors.light,
        position: 'relative',
        overflow: 'hidden'
      }}
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {/* Formes d'arrière-plan */}
      <div style={shapesStyles}>
        <div style={{
          ...glowEffect,
          top: '20%',
          left: '10%',
          background: 'rgba(58, 134, 255, 0.3)',
        }}
        />
        <div style={{
          ...glowEffect,
          bottom: '10%',
          right: '15%',
          background: 'rgba(255, 0, 110, 0.3)',
        }}
        />
      </div>

      <div style={{
        position: 'relative', zIndex: 1, maxWidth: '1200px', margin: '0 auto'
      }}
      >
        <h2 style={{
          ...sectionHeadingStyle,
          color: colors.light,
          fontSize: 'clamp(2.2rem, 4vw, 2.75rem)',
        }}
        >Ce que nos clients disent
        </h2>
        <p style={{
          ...sectionSubheadingStyle,
          color: 'rgba(255, 255, 255, 0.7)',
          maxWidth: '600px',
        }}
        >
          Découvrez l'impact réel de Drivesoft sur les entreprises de transport sanitaire
        </p>

        <motion.div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '30px',
            marginTop: '50px',
          }}
          variants={staggerVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={itemVariant}
              style={{
                background: 'rgba(255, 255, 255, 0.03)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                padding: '40px 30px',
                maxWidth: '350px',
                width: '100%',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                position: 'relative',
                overflow: 'hidden',
                willChange: 'transform'
              }}
              whileHover={{
                y: -5,
                boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
              }}
              transition={{ duration: 0.2 }}
            >
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '5px',
                background: `linear-gradient(90deg, ${index === 0 ? colors.primary : index === 1 ? colors.secondary : colors.accent}, transparent)`,
              }}
              />

              <div style={{
                fontFamily,
                fontSize: '64px',
                lineHeight: '1',
                opacity: 0.15,
                position: 'absolute',
                top: '20px',
                right: '30px',
                color: '#fff'
              }}
              >
                "
              </div>

              <p style={{
                fontStyle: 'italic',
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '1rem',
                lineHeight: '1.7',
                marginBottom: '30px',
                position: 'relative',
                zIndex: 1,
              }}
              >"{testimonial.text}"
              </p>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
              }}
              >
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                  border: '2px solid rgba(255, 255, 255, 0.1)',
                }}
                >
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <div>
                  <p style={{
                    fontWeight: '700',
                    color: '#fff',
                    fontSize: '1.1rem',
                    marginBottom: '5px',
                  }}
                  >{testimonial.name}
                  </p>
                  <p style={{
                    color: 'rgba(255, 255, 255, 0.6)',
                    fontSize: '0.9rem',
                  }}
                  >{testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
});

const ContactSection = memo(({ contactRef }) => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [focusedField, setFocusedField] = useState(null);

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://drivesoft-e728p.ondigitalocean.app/contact/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formState),
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Message envoyé',
          text: 'Le message a été envoyé avec succès.',
          confirmButtonColor: colors.primary,
        });
        setFormState({ name: '', email: '', message: '' });
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Erreur lors de l\'envoi du message.',
          confirmButtonColor: colors.primary,
        });
      }
    }
    catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Erreur lors de l\'envoi du message.',
        confirmButtonColor: colors.primary,
      });
    }
  };

  return (
    <motion.section
      id="contact-section"
      ref={contactRef}
      style={{
        ...sectionStyle,
        background: 'linear-gradient(135deg, #f8f9fa 0%, #f1f5f9 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2, margin: '-100px 0px' }}
    >
      {/* Formes d'arrière-plan */}
      <div style={shapesStyles}>
        <div style={{
          ...circleShape,
          width: '300px',
          height: '300px',
          top: '-150px',
          right: '-150px',
          background: 'rgba(58, 134, 255, 0.08)',
        }}
        />
        <div style={{
          ...circleShape,
          width: '200px',
          height: '200px',
          bottom: '50px',
          left: '50px',
          background: 'rgba(255, 0, 110, 0.08)',
        }}
        />
      </div>

      <motion.div
        style={{
          position: 'relative',
          zIndex: 1,
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '60px'
        }}
        variants={staggerVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.div variants={itemVariant} style={{ flex: '1 1 400px' }}>
          <h2 style={{
            ...sectionHeadingStyle,
            textAlign: 'left',
            position: 'relative',
            marginBottom: '20px',
            display: 'inline-block'
          }}
          >
            Parlons de votre projet
            <div style={{
              position: 'absolute',
              bottom: '-10px',
              left: '0',
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #3a86ff, #8338ec)',
              borderRadius: '2px'
            }}
            />
          </h2>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.8',
            color: '#64748b',
            marginBottom: '40px',
            maxWidth: '500px'
          }}
          >
            Vous avez des questions sur Drivesoft ?
            Notre équipe est prête à vous accompagner pour trouver la solution adaptée à vos besoins spécifiques.
          </p>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '25px',
            marginTop: '50px'
          }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px'
            }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '16px',
                background: 'rgba(58, 134, 255, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: colors.primary,
                fontSize: '24px'
              }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div>
                <h4 style={{
                  fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px', color: colors.dark
                }}
                >
                  Par téléphone
                </h4>
                <p style={{ color: '#64748b', fontSize: '1rem' }}>+33 6 52 80 77 36</p>
              </div>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px'
            }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '16px',
                background: 'rgba(255, 0, 110, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: colors.secondary,
                fontSize: '24px'
              }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <h4 style={{
                  fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px', color: colors.dark
                }}
                >
                  Par email
                </h4>
                <p style={{ color: '#64748b', fontSize: '1rem' }}>contact@drivesoft.fr</p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariant} style={{ flex: '1 1 450px' }}>
          <div style={{
            background: '#ffffff',
            borderRadius: '24px',
            padding: '40px',
            boxShadow: '0 30px 60px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(0, 0, 0, 0.05)',
            position: 'relative',
            overflow: 'hidden'
          }}
          >
            <form onSubmit={handleSubmit} style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ marginBottom: '20px' }}>
                <label
                  htmlFor="name"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    color: colors.dark
                  }}
                >
                  Nom complet
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={formState.name}
                    onChange={handleChange}
                    onFocus={() => handleFocus('name')}
                    onBlur={handleBlur}
                    style={{
                      ...inputStyle,
                      borderLeft: focusedField === 'name' ? `4px solid ${colors.primary}` : '4px solid transparent',
                      transition: 'all 0.3s ease'
                    }}
                    placeholder="Votre nom"
                    required
                  />
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label
                  htmlFor="email"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    color: colors.dark
                  }}
                >
                  Email
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formState.email}
                    onChange={handleChange}
                    onFocus={() => handleFocus('email')}
                    onBlur={handleBlur}
                    style={{
                      ...inputStyle,
                      borderLeft: focusedField === 'email' ? `4px solid ${colors.primary}` : '4px solid transparent',
                      transition: 'all 0.3s ease'
                    }}
                    placeholder="Votre email"
                    required
                  />
                </div>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <label
                  htmlFor="message"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    color: colors.dark
                  }}
                >
                  Message
                </label>
                <div style={{ position: 'relative' }}>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formState.message}
                    onChange={handleChange}
                    onFocus={() => handleFocus('message')}
                    onBlur={handleBlur}
                    style={{
                      ...inputStyle,
                      borderLeft: focusedField === 'message' ? `4px solid ${colors.primary}` : '4px solid transparent',
                      transition: 'all 0.3s ease'
                    }}
                    placeholder="Décrivez votre projet ou posez-nous vos questions"
                    required
                  />
                </div>
              </div>

              <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <motion.button
                  type="submit"
                  style={{
                    ...formButtonStyle,
                    width: '100%',
                    maxWidth: '100%',
                    fontSize: '1rem'
                  }}
                  whileHover={{
                    scale: 1.02,
                    boxShadow: '0 15px 30px rgba(58, 134, 255, 0.4)'
                  }}
                  whileTap={{ scale: 0.98 }}
                  transition={{ duration: 0.3 }}
                >
                  Envoyer le message
                </motion.button>
              </div>
            </form>

            {/* Décoration d'arrière-plan */}
            <div style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '150px',
              height: '150px',
              background: 'radial-gradient(circle, rgba(58, 134, 255, 0.1) 0%, rgba(255, 255, 255, 0) 70%)',
              zIndex: 0
            }}
            />
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '120px',
              height: '120px',
              background: 'radial-gradient(circle, rgba(255, 0, 110, 0.1) 0%, rgba(255, 255, 255, 0) 70%)',
              zIndex: 0
            }}
            />
          </div>
        </motion.div>
      </motion.div>
    </motion.section>
  );
});

// -------------------------
// CARROUSEL DES FONCTIONNALITÉS
// -------------------------
// Modern, minimalist carousel design
const FeaturesCarousel = memo(() => {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      title: 'Régulation des missions',
      description: 'Organisez et planifiez vos missions en toute simplicité. Affectez les chauffeurs et suivez l\'avancement en temps réel.',
      icon: <FaCalendarAlt />,
      color: colors.primary
    },
    {
      title: 'Facturation simplifiée',
      description: 'Automatisez votre facturation avec télétransmission, gestion des tarifs et relances pour un recouvrement efficace.',
      icon: <FaFileInvoiceDollar />,
      color: colors.secondary
    },
    {
      title: 'Tableau de bord intuitif',
      description: "Analysez vos performances avec des graphiques détaillés sur le chiffre d'affaires, les missions et les équipes.",
      icon: <FaChartBar />,
      color: colors.accent
    },
    {
      title: 'Application mobile',
      description: 'Suivez vos missions et consultez vos plannings en temps réel. Pointeuse intégrée pour remplacer le papier, remplir les procédures et enquêtes de satisfaction, consulter documents, gérer stocks, suivre événements à venir et tâches à réaliser.',
      icon: <FaMobileAlt />,
      color: colors.success
    },
    {
      title: 'Gestion des plannings',
      description: 'Optimisez la gestion des plannings de vos équipes et véhicules pour une organisation sans faille.',
      icon: <FaCalendarAlt />,
      color: colors.warning
    },
    {
      title: 'Gestion des stocks',
      description: 'Suivez et gérez vos stocks de matériel en temps réel pour éviter les ruptures.',
      icon: <FaWarehouse />,
      color: colors.primary
    },
    {
      title: 'Porte-document numérique',
      description: 'Accédez facilement à tous vos documents importants depuis une interface centralisée.',
      icon: <FaFolderOpen />,
      color: colors.secondary
    },
    {
      title: 'Analyse des données',
      description: 'Exploitez des données détaillées pour améliorer vos performances et prendre des décisions éclairées.',
      icon: <FaDatabase />,
      color: colors.accent
    },
    {
      title: 'Gestion du personnel',
      description: 'Gérez les informations et les performances de votre personnel avec des outils dédiés.',
      icon: <FaUsers />,
      color: colors.success
    },
    {
      title: 'Gestion du parc Automobile',
      description: "Suivez l'état et la maintenance de vos véhicules pour une flotte toujours opérationnelle.",
      icon: <FaCar />,
      color: colors.warning
    },
  ];

  // Modern slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    beforeChange: (current, next) => setActiveFeature(next),
    arrows: true,
    swipeToSlide: true,
    touchThreshold: 10,
    customPaging: (i) => (
      <div
        style={{
          width: '30px',
          height: '4px',
          margin: '0 4px',
          borderRadius: '2px',
          background: activeFeature === i
            ? `linear-gradient(90deg, ${colors.primary}, ${colors.secondary})`
            : 'rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease',
        }}
      />
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <motion.section
      style={{
        ...sectionStyle,
        backgroundColor: '#fafafa',
        position: 'relative',
        overflow: 'hidden',
        paddingTop: '140px',
        paddingBottom: '160px',
      }}
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {/* Subtle background elements */}
      <div style={{
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        height: '300px',
        background: 'linear-gradient(180deg, rgba(243, 244, 246, 1) 0%, rgba(250, 250, 250, 0) 100%)',
        zIndex: 0
      }}
      />

      <div style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 20px'
      }}
      >
        <motion.div
          variants={staggerVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <motion.div variants={itemVariant} style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{
              ...sectionHeadingStyle,
              position: 'relative',
              display: 'inline-block',
              fontWeight: '700',
              fontSize: 'clamp(2.2rem, 4vw, 2.8rem)',
            }}
            >
              <span>Fonctionnalités </span>
              <span style={{
                background: 'linear-gradient(90deg, #3a86ff, #8338ec)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
              >
                innovantes
              </span>
              <motion.div
                style={{
                  position: 'absolute',
                  bottom: '-15px',
                  left: '50%',
                  width: '60px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #3a86ff, #8338ec)',
                  borderRadius: '2px',
                  transform: 'translateX(-50%)',
                }}
              />
            </h2>
            <p style={{
              ...sectionSubheadingStyle,
              maxWidth: '650px',
              fontSize: '1.1rem',
              lineHeight: '1.7',
              color: '#64748b'
            }}
            >
              Découvrez les outils qui révolutionnent la gestion du transport sanitaire
            </p>
          </motion.div>

          <motion.div variants={itemVariant} style={{ position: 'relative' }}>
            {/* Custom CSS for modern slider */}
            <style>
              {`
                .features-slider .slick-list {
                  margin: 0 -20px;
                  padding: 20px 0 40px;
                  overflow: visible;
                }
                
                .features-slider .slick-track {
                  display: flex;
                  align-items: stretch;
                }
                
                .features-slider .slick-slide {
                  height: auto;
                  padding: 0 20px;
                  opacity: 0.5;
                  transform: scale(0.95);
                  transition: all 0.6s ease;
                  touch-action: pan-y;
                }
                
                .features-slider .slick-slide.slick-active {
                  opacity: 1;
                  transform: scale(1);
                }
                
                .features-slider .slick-slide.slick-center {
                  transform: scale(1.03);
                }
                
                .features-slider .slick-slide > div {
                  height: 100%;
                }
                
                .feature-card {
                  height: 380px !important;
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                }
                
                .feature-card-content {
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                }
                
                .feature-title {
                  height: 60px;
                  display: flex;
                  align-items: center;
                }
                
                .feature-description {
                  flex: 1;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 4;
                  -webkit-box-orient: vertical;
                }
                
                .features-slider .slick-prev,
                .features-slider .slick-next {
                  width: 50px;
                  height: 50px;
                  background: white;
                  border-radius: 50%;
                  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
                  z-index: 10;
                  transition: all 0.3s ease;
                  display: flex !important;
                  align-items: center;
                  justify-content: center;
                }
                
                .features-slider .slick-prev:before,
                .features-slider .slick-next:before {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 24px;
                  color: #3a86ff;
                  opacity: 1;
                }

                .features-slider .slick-prev:before {
                  content: '←';
                }

                .features-slider .slick-next:before {
                  content: '→';
                }
                
                .features-slider .slick-prev:hover,
                .features-slider .slick-next:hover {
                  background: linear-gradient(90deg, #3a86ff20, #8338ec20);
                  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
                }
                
                .features-slider .slick-prev {
                  left: -25px;
                }
                
                .features-slider .slick-next {
                  right: -25px;
                }
                
                .features-slider .slick-dots {
                  bottom: -40px;
                  display: flex !important;
                  justify-content: center;
                  gap: 5px;
                }
                
                .features-slider .slick-dots li {
                  width: auto;
                  height: auto;
                  margin: 0;
                }
                
                @media (max-width: 768px) {
                  .features-slider .slick-list {
                    overflow: hidden;
                  }
                  
                  .features-slider .slick-prev {
                    left: 10px;
                  }
                  
                  .features-slider .slick-next {
                    right: 10px;
                  }
                  
                  .feature-card {
                    height: 350px !important;
                  }
                  
                  /* Improved mobile touch indicators */
                  .features-slider::after {
                    content: '';
                    position: absolute;
                    bottom: -30px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 60px;
                    height: 4px;
                    background: rgba(0, 0, 0, 0.1);
                    border-radius: 2px;
                    opacity: 0.5;
                  }
                }
              `}
            </style>

            <div className="features-slider">
              <Slider {...settings}>
                {features.map((feature, index) => (
                  <div key={index} style={{ height: '100%' }}>
                    <motion.div
                      className="feature-card"
                      style={{
                        background: 'white',
                        borderRadius: '16px',
                        padding: '40px 30px',
                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.04)',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        border: '1px solid rgba(0, 0, 0, 0.03)',
                        transition: 'all 0.4s ease',
                        overflow: 'hidden'
                      }}
                      whileHover={{
                        y: -8,
                        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)',
                      }}
                    >
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '5px',
                        width: '100%',
                        background: `linear-gradient(90deg, ${feature.color}, ${feature.color}80)`,
                      }}
                      />

                      <div className="feature-card-content">
                        <div style={{
                          width: '60px',
                          height: '60px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '25px',
                          fontSize: '24px',
                          color: feature.color,
                          position: 'relative'
                        }}
                        >
                          {feature.icon}
                        </div>

                        <h3
                          className="feature-title"
                          style={{
                            fontSize: '1.3rem',
                            fontWeight: '700',
                            color: colors.dark,
                            marginBottom: '15px',
                            position: 'relative'
                          }}
                        >
                          {feature.title}
                        </h3>

                        <p
                          className="feature-description"
                          style={{
                            fontSize: '0.95rem',
                            color: '#64748b',
                            lineHeight: '1.7',
                            position: 'relative',
                            marginBottom: '20px'
                          }}
                        >
                          {feature.description}
                        </p>
                      </div>
                    </motion.div>
                  </div>
                ))}
              </Slider>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
});

// -------------------------
// COMPOSANT PRINCIPAL DE LA PAGE D'ACCUEIL
// -------------------------
// Main component optimization
function HomePage() {
  const featuresSectionRef = useRef(null);
  const contactRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    // Optimize scroll listener with throttling
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Effet pour supprimer la boule rouge
  useEffect(() => {
    // Chercher et supprimer le div avec les propriétés spécifiques
    const divToRemove = document.querySelector('div[style*="filter: blur(90px)"][style*="rgba(255, 0, 110, 0.2)"]');
    if (divToRemove) {
      divToRemove.remove();
    }
  }, []);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div style={{ overflow: 'hidden' }}>
      {/* SECTION HERO - Optimize by reducing particle effects further */}
      <div style={{
        ...heroStyle,
        position: 'relative',
      }}
      >
        <div style={overlayStyle} />

        {/* Reduce particles even more and optimize their animation */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          overflow: 'hidden'
        }}
        >
          {Array.from({ length: 5 }).map((_, index) => (
            <motion.div
              key={index}
              style={{
                position: 'absolute',
                width: 6,
                height: 6,
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
                borderRadius: '50%',
                top: `${index * 20}%`,
                left: `${index * 20}%`,
                zIndex: 1,
              }}
              animate={{
                y: [0, 40],
                opacity: [0.7, 0.1],
              }}
              transition={{
                duration: 8,
                repeat: Infinity,
                repeatType: 'reverse',
                ease: 'linear'
              }}
            />
          ))}
        </div>

        <div style={{
          ...contentStyle,
          transform: scrollY > 0 ? `translateY(${Math.min(scrollY * 0.2, 100)}px)` : 'none', // Limit transform and skip when not needed
          willChange: scrollY > 0 ? 'transform' : 'auto', // Only use willChange when needed
        }}
        >
          <motion.div
            variants={staggerVariant}
            initial="hidden"
            animate="visible"
            transition={{ staggerChildren: 0.1, delayChildren: 0.1 }}
          >

            <motion.h1
              variants={itemVariant}
              style={headlineStyle}
            >
              La solution innovante pour
              <br />
              le transport sanitaire
            </motion.h1>

            <motion.p
              variants={itemVariant}
              style={subheadStyle}
            >
              Optimisez vos opérations, simplifiez votre facturation et améliorez la gestion de vos équipes
              avec une plateforme intuitive et sécurisée.
            </motion.p>

            <motion.div
              variants={itemVariant}
              style={{
                display: 'flex',
                gap: '20px',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <motion.button
                style={buttonStyle}
                whileHover={{
                  scale: 1.05,
                  boxShadow: '0 15px 30px rgba(58, 134, 255, 0.4)'
                }}
                whileTap={{ scale: 0.98 }}
                transition={{ duration: 0.3 }}
                onClick={() => scrollToSection(contactRef)}
              >
                Demander une démo
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </motion.button>

              <motion.button
                style={secondaryButtonStyle}
                whileHover={{
                  scale: 1.05,
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }}
                whileTap={{ scale: 0.98 }}
                transition={{ duration: 0.3 }}
                onClick={() => scrollToSection(featuresSectionRef)}
              >
                Découvrir les fonctionnalités
              </motion.button>
            </motion.div>
          </motion.div>
        </div>

      </div>

      {/* Optimize section loading with lazy rendering */}
      <div ref={featuresSectionRef}>
        <FeaturesCarousel />
      </div>

      <AboutSection />
      <TestimonialsSection />
      <ContactSection contactRef={contactRef} />
    </div>
  );
}

export default memo(HomePage);
